var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Warning,{attrs:{"tree-title":"竞争对手","body-title":"竞争对手预警","category-field":_setup.categoryField}})
}
var staticRenderFns = []

export { render, staticRenderFns }